import styled from 'styled-components'

export const Tooltip = ({ text, show }: { text: string; show: boolean }) => {
  return <Text show={show}>{text}</Text>
}

const Text = styled.div<{ show: boolean }>`
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  width: 120px;
  background-color: ${({ theme }) => theme.colorText};
  color: var(--site-background);
  text-align: center;
  padding: 0.5rem 0.5rem;
  line-height: 1.4;
  font-size: 0.85em;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);

  /* Fade in tooltip */
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }
`
